export class WebhookV1StandardPayloadBackupJobPartialArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobPartial",
            "baseName": "backupJobPartial",
            "type": "WebhookV1BackupJobPartialArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobPartialArguments.attributeTypeMap;
    }
    constructor() {
    }
}
